import logoCdi from "@/assets/logo-cdi.svg";

// AuthCard — CDI-branded card wrapper for every auth screen.
// Centered CDI logo + charcoal card on a subtle dark surface.
export default function AuthCard({ title, subtitle, children, footer }) {
  return (
    <div
      className="min-h-screen w-full flex items-center justify-center px-4 py-12"
      style={{ background: "#0f0f0f" }}
      data-testid="auth-card-root"
    >
      <div
        className="w-full max-w-md rounded-xl p-8 border"
        style={{
          background: "#1a1a1a",
          borderColor: "#2a2a2a",
          boxShadow: "0 20px 60px rgba(0,0,0,0.4)",
        }}
      >
        <div className="flex flex-col items-center mb-8" data-testid="auth-card-logo">
          <img src={logoCdi} alt="CDI Collectables" width={180} />
        </div>
        {title && (
          <h1
            className="text-xl font-semibold mb-2 text-center"
            style={{ color: "#f7f7f7", letterSpacing: "0.3px" }}
            data-testid="auth-card-title"
          >{title}</h1>
        )}
        {subtitle && (
          <p className="text-sm text-center mb-6" style={{ color: "#9a9a9a" }}
             data-testid="auth-card-subtitle">{subtitle}</p>
        )}
        {children}
        {footer && (
          <div className="mt-6 pt-4 border-t text-center text-xs"
               style={{ borderColor: "#2a2a2a", color: "#6f6f6f" }}
               data-testid="auth-card-footer">{footer}</div>
        )}
      </div>
    </div>
  );
}
